import Seo, { Breadcrumbs } from "@/components/Seo";
import { ShieldCheck } from "lucide-react";

export default function Insurance() {
  return (
    <div className="container-bl py-10 max-w-3xl" data-testid="page-insurance">
      <Seo title="Insurance Requirements · Vehicle Rentals in Oxnard | B&L Rentals" description="What insurance you need to rent a vehicle from B&L Rentals in Oxnard, Ventura County." canonical={typeof window !== "undefined" ? window.location.origin + "/insurance-requirements" : undefined} />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Insurance" }]} />
      <div className="flex items-center gap-3">
        <ShieldCheck size={28} className="text-[#E2AB20]" />
        <h1 className="text-4xl font-heading font-bold text-white">Insurance requirements</h1>
      </div>
      <p className="mt-3 text-[#AEB9C9]">You must show proof of active personal auto insurance before we release the vehicle.</p>

      <div className="mt-8 space-y-6 text-[#E5EAF2] leading-relaxed">
        <section>
          <h2 className="text-xl font-heading font-semibold text-white">What we require</h2>
          <ul className="mt-2 list-disc pl-6 space-y-1 text-sm">
            <li>Active personal auto insurance policy in the renter's name.</li>
            <li>Minimum California liability limits: 15/30/5 (bodily / accident / property).</li>
            <li>Comprehensive & collision recommended (required for vehicles priced over $150/day).</li>
            <li>Policy must transfer to rental vehicles (most major carriers do — verify with yours).</li>
          </ul>
        </section>
        <section>
          <h2 className="text-xl font-heading font-semibold text-white">Accepted carriers</h2>
          <p className="mt-2 text-sm">State Farm, GEICO, Progressive, Allstate, Farmers, USAA, Liberty Mutual, Nationwide, AAA, Mercury, and most regional carriers. If yours isn't listed, call us first.</p>
        </section>
        <section>
          <h2 className="text-xl font-heading font-semibold text-white">Proof of insurance</h2>
          <p className="mt-2 text-sm">Bring your insurance card or a screenshot of your carrier's app showing policy number, dates, and named insured. We verify against your license at pickup.</p>
        </section>
        <section>
          <h2 className="text-xl font-heading font-semibold text-white">Don't have insurance?</h2>
          <p className="mt-2 text-sm">We cannot rent without an active policy. Consider getting a short-term Non-Owner Policy — most carriers offer them in California for $30–$60/month.</p>
        </section>
      </div>
    </div>
  );
}
